module.exports = __webpack_public_path__ + "img/V84.d7e29cfe.jpg";